export const customEvents = {
  GA_LOGOUT: {
    action: "GA_LOGOUT",
    category: "click",
    label: "Clicked - Logout",
  },
  GA_DASHBOARD: {
    action: "GA_DASHBOARD",
    category: "click",
    label: "Clicked - Dashboard",
  },
  GA_TEAMS: {
    action: "GA_TEAMS",
    category: "click",
    label: "Clicked - Teams",
  },
  GA_PROFILE: {
    action: "GA_PROFILE",
    category: "click",
    label: "Clicked - Profile",
  },
  GA_CLIENTS_VIEW: {
    action: "GA_CLIENTS_VIEW",
    category: "click",
    label: "Clicked - View Client",
  },
  GA_CLIENTS_LOGIN: {
    action: "GA_CLIENTS_LOGIN",
    category: "click",
    label: "Login - Client",
  },
  GA_ADD_NEWUSER: {
    action: "GA_ADD_NEWUSER",
    category: "click",
    label: "Clicked - Assigned Clients Tab",
  },
  GA_VIEW_MEMBER: {
    action: "GA_VIEW_MEMBER",
    category: "click",
    label: "Clicked - Team Member Details",
  },
  GA_UPDATE_MEMBER: {
    action: "GA_UPDATE_MEMBER",
    category: "click",
    label: "Clicked - Team Member Update Details",
  },
  GA_ADD_USER: {
    action: "GA_ADD_USER",
    category: "click",
    label: "Clicked - Add New User",
  },

  GA_UNASSIGN_CONFIRM: {
    action: "GA_UNASSIGN_CONFIRM",
    category: "click",
    label: "Confirm - Unassign",
  },
  GA_UNASSIGN_CANCEL: {
    action: "GA_UNASSIGN_CANCEL",
    category: "click",
    label: "Cancelled - Unassign",
  },
  GA_MOVECLIENTS: {
    action: "GA_MOVE_CLIENTS",
    category: "click",
    label: "Moved - Clients",
  },
  GA_CANCEL_MOVECLIENTS: {
    action: "GA_CANCEL_MOVE_CLIENTS",
    category: "click",
    label: "Cancelled - Move Clients",
  },
  GA_CLIENTS_ASSIGN: {
    action: "GA_CLIENTS_ASSIGN",
    category: "click",
    label: "Clicked - Assign New User",
  },
  GA_CLIENTS_ASSIGN_CANCELLED: {
    action: "GA_CLIENTS_ASSIGN_CANCELLED",
    category: "click",
    label: "Clicked - Assign New User Cancelled",
  },
  GA_INVITE_USER: {
    action: "GA_INVITE_USER",
    category: "click",
    label: "Invited - Add New User",
  },
  GA_UPDATE_USER: {
    action: "GA_UPDATE_USER",
    category: "click",
    label: "Invited - Update User",
  },
  GA_CANCEL_USER: {
    action: "GA_CANCEL_USER",
    category: "click",
    label: "Cancelled - Add New User",
  },
  GA_CLIENTS: {
    action: "GA_CLIENTS",
    category: "click",
    label: "Clients Clicked",
  },
  GA_ROLES: {
    action: "GA_ROLES",
    category: "click",
    label: "Roles Clicked",
  },
  GA_HELPDESK: {
    action: "GA_HELPDESK",
    category: "click",
    label: "HelpDesk Clicked",
  },
  GA_NEWS_AND_ALERTS: {
    action: "GA_NEWS_AND_ALERTS",
    category: "click",
    label: "Clicked - News and Alerts",
  },
  GA_GLOBAL_ROLES:{
    action: "GA_GLOBAL_ROLES",
    category: "click",
    label: "Clicked - Global roles",
  },
  GA_ROLES_SYNCED: {
    action: "GA_ROLES_SYNCED",
    category: "click",
    label: "Roles Synced Successfully",
  },
  GA_GLOBAL_ROLE_CHANGED: {
    action: "GA_GLOBAL_ROLE_CHANGED",
    category: "click",
    label: "Global Role Changed Successfully",
  },
  GA_PROFILE_UPDATED: {
    action: "GA_PROFILE_UPDATED",
    category: "click",
    label: "User Profile Updated Successfully",
  },
  GA_CHANGE_PASSWORD: {
    action: "GA_CHANGE_PASSWORD",
    category: "click",
    label: "Change Password Clicked",
  },
  GA_VIEW_ASSIGNEDCLIENTS: {
    action: "GA_VIEW_ASSIGNEDCLIENTS",
    category: "click",
    label: "Clicked - Assigned Clients Tab",
  },
  GA_VIEW_MOVECLIENTS: {
    action: "GA_VIEW_MOVECLIENTS",
    category: "click",
    label: "Clicked - Move Clients Tab",
  },
  GA_VIEW_ASSIGNCLIENTS: {
    action: "GA_VIEW_ASSIGNCLIENTS",
    category: "click",
    label: "Clicked - Assign Clients Tab",
  },
  GA_CANCEL_ASSIGNCLIENTS: {
    action: "GA_CANCEL_ASSIGNCLIENTS",
    category: "click",
    label: "Cancelled - Assign Clients",
  },
  GA_ASSIGNCLIENTS: {
    action: "GA_ASSIGNCLIENTS",
    category: "click",
    label: "Assigned - Clients",
  },
  GA_EXIT_ASSIGN: {
    action: "GA_EXIT_ASSIGN",
    category: "click",
    label: "Exit - Assign New",
  },
  GA_UNASSIGN_EXIT: {
    action: "GA_UNASSIGN_EXIT",
    category: "click",
    label: "Exit - Unassign",
  },
  GA_ROLES_SourceAcc_NEXT: {
    action: "GA_ROLES_SourceAcc_NEXT",
    category: "click",
    label: "Clicked on Next after selecting source account",
  },
  GA_ROLES_greytHRrole_NEXT: {
    action: "GA_ROLES_SourceAcc_NEXT",
    category: "click",
    label: "Clicked on Next after seleting the greytHR roles",
  },
  GA_ROLES_Synchronize_: {
    action: "GA_ROLES_Synchronize_",
    category: "click",
    label: "Clicked on synchronize after seleting the destination account ",
  },
  GA_MANAGE_SLA: {
    action: "GA_MANAGE_SLA",
    category: "click",
    label: "Clicked on Manage SLA table ",
  },
};
